<template>
    <div>
        <az-back-button :route="{name: 'comissoesBusca'}" text="Voltar para listagem"></az-back-button>
        <az-container>
            <comissao-acoes/>
            <comissao-dados v-model="comissao" :orgaos-list="orgaosList" inserindo/>
            <div class="az-actions-form" v-az-auth="'Comissao.Atualizar'">
                <div class="align-left"></div>
                <div class="align-right">
                    <button class="action-secundary" @click="cancelar">Cancelar</button>
                    <button class="action-primary" @click.prevent="salvar">Salvar</button>
                </div>
            </div>
        </az-container>
    </div>
</template>

<script>
import {mapActions} from 'vuex'
import {actionTypes} from '@/commons/constants'
import ComissaoAcoes from './ComissaoAcoes'
import ComissaoDados from './ComissaoDados'

export default {
        name: 'ComissaoNovo',
        components: {ComissaoAcoes, ComissaoDados},
        data() {
            return {
                comissao: {
                    comissaoApuracao: {
                      orgao: { id: null, nome: null, logradouro: null, numeroLogradouro: null, bairro: null }
                    },
                    comissaoConfiguracao: {},
                    comissaoUsuarios: []
                },
                orgaosList: []
            }
        },
        async mounted() {
          await this.buscarOrgaos()
        },
        methods: {
            ...mapActions([actionTypes.INSERIR_COMISSAO]),
            cancelar() {
                this.$router.push({name: 'comissoesBusca'})
            },
            redirecionarParaEdicao() {
                this.$router.push({
                    name: 'comissaoAtualizacao',
                    params: {
                        id: this.comissao.comissaoApuracao.id
                    },
                    query: {
                        edicao: true
                    }
                })
            },
            async buscarOrgaos(){
              const response = await this.$store.dispatch(actionTypes.BUSCAR_ORGAOS)
              if(response){
                this.orgaosList = response
              }
            },
            async salvar() {
                const validado = await this.$validator._base.validateAll()
                if (!validado) {
                    return
                }
                if(!this.comissao.comissaoApuracao.orgao.id){
                  this.mostrarNotificacaoErro('Informe o órgão da comissão!')
                  return
                }
                this.setMensagemLoading('Salvando comissão...')
                this.comissao = await this.inserirComissao(this.comissao)
                this.redirecionarParaEdicao()
            }
        }
    }
</script>
